<template>
    <l-map ref="mainMap" style="height:480px;"
        :options="{ zoomControl: false }"
        :zoom="zoom" 
        :center="center">
        <l-control-zoom position="topright"></l-control-zoom>         

        <l-control-scale 
            :imperial="scale.imperial" 
            :maxWidth="scale.maxWidth" 
            position="bottomleft">
        </l-control-scale> 

        <l-control-layers position="bottomright"></l-control-layers>        
        <l-tile-layer ref="tileLayer" layerType="base"
            v-for="tileProvider in baseTileProviders"
            :key="tileProvider.name"
            :name="tileProvider.name"
            :visible="tileProvider.visible"
            :url="tileProvider.url"
            :options="tileProvider.options"
            :attribution="tileProvider.attribution">
        </l-tile-layer>  
        <l-tile-layer layerType="overlay" 
            v-for="tileProvider in overlayTileProviders"
            :key="tileProvider.name"
            :name="tileProvider.name"
            :visible="tileProvider.visible"
            :url="tileProvider.url"
            :attribution="tileProvider.attribution">                        
        </l-tile-layer> 

        <l-geo-json v-if="track" layerType="overlay" name="Track"
            :geojson="track"
            :options="trackStyle">
        </l-geo-json> 

        <l-feature-group v-if="markers" ref="fgroup" :visible="markersVisible" layerType="overlay" name="Pontok">
            <l-marker v-for="marker in markers"
                :key="marker.id"
                :visible="marker.visible"
                :lat-lng="marker.position"
                :title="marker.text"
                :icon="marker.icon">
                <l-popup >
                    <div v-if="marker.allInfo">
                        <img :src="marker.allInfo.img" style="width:100%" class="w3-card-2">
                        <div class="w3-container w3-white">                 
                            <p><b>{{marker.allInfo.name}}</b></p>
                            <div class="w3-right">{{marker.allInfo.price}} {{$appData.currency}}</div>
                            <p>{{marker.allInfo.distance}} km / {{marker.allInfo.level}} m</p>
                            <p class="w3-justify">{{marker.allInfo.description | filterTruncate(300)}}</p>
                            <div class="w3-center w3-margin">
                                <div v-on:click="$router.push('/routeinfo/'+marker.allInfo.id)" class="w3-button w3-border w3-hover-green w3-margin-right" style="width:100px;">Részletek</div>                        
                            </div>
                        </div>
                    </div>
                    <div v-else>{{marker.text}}</div>
                </l-popup>
            </l-marker>      
        </l-feature-group>          


    </l-map>    
</template>

<script>
var mapSettings = require('../assets/jsons/mapSettings.json')
import {LMap, LGeoJson, LTileLayer, LControlScale, LIcon, LMarker, LPolyline, LPopup, LTooltip, LControlLayers, LLayerGroup, LFeatureGroup, LControl, LControlZoom, LCircle} from 'vue2-leaflet';

export default {
    name: 'Map', 
    data() {
        return {
          zoom: 8,
          center: L.latLng(this.$appData.map.center.lat, this.$appData.map.center.lng),
          baseTileProviders: null,
          overlayTileProviders: null,
          scale: mapSettings.scale,
          trackStyle: mapSettings.trackStyle,
          markersVisible: true,
        }
    }, 
    props: {
        track: {
            type: Object,
            default: function () {
                return null;
            }
        },
        markers: {
            type: Array,
            default: function () {
                return null;
            }
        }                     
    },
    methods:{
      mapSettings(){
        const appSetting=this.$storage.get('appSettings', false);
        if (appSetting) {
            const tpName=appSetting.map.tileProvider;
            for (var i in mapSettings.baseTileProviders) {
                mapSettings.baseTileProviders[i].visible=(mapSettings.baseTileProviders[i].name==tpName);
            }
            this.baseTileProviders=mapSettings.baseTileProviders;
            mapSettings.overlayTileProviders[0].visible=appSetting.map.layers.turistautak;
            mapSettings.overlayTileProviders[1].visible=appSetting.map.layers.szintvonalak; 
            this.overlayTileProviders=mapSettings.overlayTileProviders;
        }
      },
      addControls(){          
        const map = this.$refs.mainMap.mapObject;
        map.addControl(new window.L.Control.Fullscreen({ "position": "topright" }));
        if (this.markers) {
            const fgroup = this.$refs.fgroup.mapObject;
            map.fitBounds(fgroup.getBounds());//Ez állítja be a térkép pozíciót a pontok alapján 
        }         
      },      
    },   
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPolyline,
        LPopup,
        LTooltip,
        LControl,
        LIcon,
        LControlZoom,
        LControlLayers,
        LLayerGroup,
        LFeatureGroup,
        LControlScale,
        LGeoJson,
        LCircle
    },
    mounted(){
        this.$nextTick(() => {
            try {
                this.addControls();
            }catch(e){
                console.log(e);
            }  
        });        
    },
    created(){
        this.mapSettings();
    }
}
</script>

